// src/pages/DashboardPage.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";

import LayoutDesktop from "../layouts/LayoutDesktop";
import LayoutMobile from "../layouts/LayoutMobile";

import DashboardDesktop from "../templates/desktop/DashboardDesktop";
import DashboardMobile from "../templates/mobile/DashboardMobile";

// Hook simples pra detectar mobile x desktop
function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= breakpoint);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
}

export default function DashboardPage() {
  const { usuario } = useAuth();
  const { tema, alterarTema } = useTheme();
  const isMobile = useIsMobile(900);

  const [sidebarAberta, setSidebarAberta] = useState(false);

  const titulo = "Dashboard";
  const subtitulo = "";

  // Versão MOBILE
  if (isMobile) {
    return (
      <LayoutMobile
        tema={tema}
        alterarTema={alterarTema}
        titulo={titulo}
        sidebarAberta={sidebarAberta}
        onToggleSidebar={() => setSidebarAberta((prev) => !prev)}
        abaBottom="home"
      >
        <DashboardMobile />
      </LayoutMobile>
    );
  }

  // Versão DESKTOP
  return (
    <LayoutDesktop
      tema={tema}
      sidebarAberta={true}
      titulo={titulo}
      subtitulo={subtitulo}
      usuario={usuario?.email || "Usuário Mamute"}
      empresa="Phoenix Injeção"
    >
      <DashboardDesktop />
    </LayoutDesktop>
  );
}
